@let parameters = parameters$ | async;
@if (parameters?.[0]?.value) {
  <app-open-parameters-atom
    [items]="parameters ?? []"
    [iconBackgroundColor]="iconBackgroundColor"
    [iconColor]="iconColor"
    [textColor]="textColor"
    (click)="openParameters()"
  ></app-open-parameters-atom>
}
